import { deserialize } from 'cerialize'
import { ShortDataModel } from 'Models'
import { TerritorialManagerType } from 'Pages/referenceBooks'

export class BankModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public code: string
	@deserialize public short_name: string | null
	@deserialize public sber_mq_regions: ShortDataModel[]
	@deserialize public terr_managers: TerritorialManagerType[]
	@deserialize public is_active: boolean

	public get active(): string | undefined {
		return this?.is_active ? 'Активен' : 'Не активен'
	}
}
